import type { ReactNode } from "react";
import { useKaya } from "../store/kayaStore";

/**
 * Standard content wrapper: centres at 680px like the original `.screen > .inner`. The install
 * and update prompts are Notices on Today now, not a bar over every page.
 */
export function Screen({ children }: { children: ReactNode }) {
  return <div className="kaya inner">{children}</div>;
}

export function Toast() {
  const toast = useKaya((s) => s.toast);
  const action = useKaya((s) => s.toastAction);
  const clear = useKaya((s) => s.clearToast);
  return (
    <div className={`toast${toast ? " show" : ""}${action ? " k-toast--act" : ""}`} role="status">
      {toast}
      {action && toast ? (
        <button
          type="button"
          className="k-toast__act"
          onClick={() => {
            action.onClick();
            clear();
          }}
        >
          {action.label}
        </button>
      ) : null}
    </div>
  );
}
